import React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

import type { AgreementsAlertBody } from '../alertHover.types'
import { agreementsStyles } from './Agreements.styles'

const AgreementsBody: React.FC<{ body: AgreementsAlertBody }> = ({ body }) => {
  if (!body || body.length === 0) return null

  return (
    <Box sx={agreementsStyles.root}>
      {body?.map((item, index) => (
        <Box key={index} sx={agreementsStyles.row}>
          <Typography sx={agreementsStyles.index}>{index + 1}</Typography>
          <Typography sx={agreementsStyles.label}>
            {item?.name && item?.date ? `${item.name}, ${item.date}` : item?.name}
          </Typography>
        </Box>
      ))}
    </Box>
  )
}

export default AgreementsBody
